/* eslint-disable no-param-reassign */
const pathAnalyser = json => (images = []) => {
  images.forEach((lottieImg) => {
    const name = lottieImg.match(/[^/]+\.png$/g)[0];
    const path = lottieImg.replace(/[^/]+$/, '');
    json.assets.forEach((obj) => {
      if (obj.layers) {
        // 组合图层不处理
        return;
      }
      if (name.includes(obj.p.replace('.png', ''))) {
        obj.u = path.includes('/lottie/') ? path : `${path}lottie/`;
        obj.p = name;
      }
    });
  });
  return json;
};

export default pathAnalyser;
